import React from 'react';
import s from './styles.module.scss';
import { ReciterAudioSurah } from '@/infrastructure/class/reciter-audio-surah';
import { useTranslation } from 'next-i18next';
import ReciterSelectorForm from './form';
import { Menu } from '@mui/material';
import { KeyboardArrowDownRounded } from '@mui/icons-material';
import classNames from 'classnames';

interface IReciterSelectorProps {
  items: ReciterAudioSurah[];
  className?: string;
}

const ReciterSelector: React.FC<IReciterSelectorProps> = (props) => {
  const { items, className } = props;

  const { t: tButtons } = useTranslation('buttons');

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const containerClassNames = classNames(className);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className={containerClassNames}>
      <button className={s['button']} onClick={handleClick}>
        <span>{tButtons('reciters')}</span>
        <i>
          <KeyboardArrowDownRounded />
        </i>
      </button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <ReciterSelectorForm items={items} onClose={handleClose} />
      </Menu>
    </div>
  );
};

export default ReciterSelector;
